import { takeLatest, all, call, put, select } from "redux-saga/effects";
import { request } from "@app/services";
import {
  category,
  categorySuccess,
  categoryFailed,
  getParentCategorySuccess,
  getParentCategoryFailed,
  getParentCategory,
  addCategory,
  addCategoryFailed,
  addCategorySuccess,
  deleteCategory,
  updateCategory,
  updateCategorySuccess,
  updateCategoryFailed,
  deleteCategorySuccess,
  deleteCategoryFailed,
} from "./slice";
import * as endpoints from "./endpoints";
import { selectAllCategoryDataState } from "./selector";

function* getAllCategorySaga({ payload }: ReturnType<typeof category>): any {
  try {
    const response = yield call(request.get, `${endpoints.allCategory}`);
    yield put(categorySuccess(response));
  } catch (error: any) {
    yield put(categoryFailed(error));
  }
}
//
function* deleteCategoryByIdSaga({
  payload,
}: ReturnType<typeof deleteCategory>): any {
  try {
    const { id } = payload;

    const { data } = yield select(selectAllCategoryDataState);

    const response = yield call(
      request.delete,
      `${endpoints.deleteCategory}/${id}`
    );

    const updatedData =
      data?.data?.length > 0
        ? data?.data?.filter((item: any) => item.id !== id)
        : [];

    yield put(categorySuccess({ ...data, data: updatedData }));
    yield put(deleteCategorySuccess(response.data));
  } catch (error: any) {
    yield put(deleteCategoryFailed(error));
  }
}

function* updateCategoryByIdSaga({
  payload,
}: ReturnType<typeof updateCategory>): any {
  try {
    const { id, name, images, parentCategoryId } = payload;

    const { data } = yield select(selectAllCategoryDataState);

    const requestBody: any = {
      name,
      parentCategoryId,
    };

    if (images) {
      requestBody["images"] = images;
    }

    const response = yield call(
      request.patch,
      `${endpoints.updateCategoryById}/${id}`,
      requestBody
    );

    const updatedData =
      data?.data?.length > 0 && response?.data?.id
        ? data.data.map((item: any) =>
            item?.id === response.data.id ? response.data : item
          )
        : data?.data || [];

    yield put(categorySuccess({ ...data, data: updatedData }));
    yield put(updateCategorySuccess(response.data));
  } catch (error: any) {
    yield put(updateCategoryFailed(error));
  }
}

function* getParentCategorySaga({
  payload,
}: ReturnType<typeof getParentCategory>): any {
  try {
    const response = yield call(request.get, `${endpoints.getparentCategory}`);
    yield put(getParentCategorySuccess(response));
  } catch (error: any) {
    yield put(getParentCategoryFailed(error));
  }
}

//

function* addCategorySaga({ payload }: ReturnType<typeof addCategory>): any {
  try {
    const { name, image, parentCategoryId } = payload;
    const { data: allCategories } = yield select(selectAllCategoryDataState);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("parentCategoryId", parentCategoryId || "");
    formData.append("image", image);
    const response = yield call(
      request.post,
      endpoints.addCategoryEndpoint,

      { name, image, parentCategoryId }
    );
    const updatedData = {
      ...allCategories,
      data: [
        ...(allCategories?.data?.length ? allCategories.data : []),
        response?.data,
      ],
    };
    yield put(categorySuccess(updatedData));
    yield put(addCategorySuccess(response.data));
  } catch (error: any) {
    yield put(addCategoryFailed(error));
  }
}

function* categorySagas() {
  yield all([takeLatest(category, getAllCategorySaga)]);
  yield all([takeLatest(addCategory, addCategorySaga)]);
  yield all([takeLatest(getParentCategory, getParentCategorySaga)]);
  yield all([takeLatest(deleteCategory, deleteCategoryByIdSaga)]);
  yield all([takeLatest(updateCategory, updateCategoryByIdSaga)]);
}

export { categorySagas };
